import React from 'react';

const FieldError = (props) => (
  <div className="field-error">
    {props.message}
  </div>
);

export default FieldError;



// WEBPACK FOOTER //
// ./src/core/components/FieldError.js